import { NgModule } from '@angular/core';

import { BaseLayoutModule } from './base/base.module';

@NgModule({
  imports: [BaseLayoutModule],
  exports: [BaseLayoutModule],
})
export class LayoutModule {}
